import { render, staticRenderFns } from "./CRMMetrics.vue?vue&type=template&id=51748d5a&scoped=true"
import script from "./CRMMetrics.vue?vue&type=script&lang=js"
export * from "./CRMMetrics.vue?vue&type=script&lang=js"
import style0 from "./CRMMetrics.vue?vue&type=style&index=0&id=51748d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51748d5a",
  null
  
)

export default component.exports